import { makeStyles } from '@eagleview/ev-comp-library';
import { random } from 'lodash';
import { setMonogramColor } from 'utils/app.utils';

const useStyles = makeStyles((theme) => {
  const raspberry = theme.evPalette.raspberry[400];
  const tulip = theme.evPalette.tulip[500];
  const lime = theme.evPalette.lime[400];
  const huckleberry = theme.evPalette.huckleberry[400];
  const marigold = theme.evPalette.marigold[600];
  const aloe = theme.evPalette.aloe[600];
  const monogramColours = [raspberry, tulip, lime, huckleberry, marigold, aloe];
  const colorValue = localStorage.getItem('ev_mgc');
  const monogramColour = colorValue ? window.atob(colorValue) : monogramColours[Math.floor(random(0, 1, true) * monogramColours.length)];
  setMonogramColor(monogramColour);

  return {
    container: {
      textAlign: 'center',
    },
    keyboardArrowDown: {
      color: theme.palette.common.white,
      margin: `${theme.spacing(1.5)}px ${theme.spacing(0.5)}px`,
    },
    box: {
      display: 'inline-flex',
    },
    avatarMicro: {
      fontSize: '14px',
      fontWeight: 'normal',
      display: 'inline-flex',
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: monogramColour,
      '&:hover': {
        filter: 'brightness(130%)',
      },
      '&:active': {
        filter: 'brightness(70%)',
      },
    },
    avatarSmall: {
      fontSize: theme.spacing(1.5),
      fontWeight: 'normal',
      lineHeight: theme.spacing(3),
      display: 'inline-flex',
      width: theme.spacing(4),
      height: theme.spacing(4),
      backgroundColor: monogramColour,
      '&:hover': {
        filter: 'brightness(130%)',
      },
      '&:active': {
        filter: 'brightness(70%)',
      },
    },
    avatarMedium: {
      fontSize: theme.typography.pxToRem(16),
      fontWeight: 'normal',
      width: theme.spacing(6),
      height: theme.spacing(6),
      backgroundColor: monogramColour,
      '&:hover': {
        filter: 'brightness(130%)',
      },
      '&:active': {
        filter: 'brightness(70%)',
      },
    },
    avatarLarge: {
      width: theme.spacing(10),
      height: theme.spacing(10),
      backgroundColor: monogramColour,
    },
    name: {
      textTransform: 'capitalize',
      color: theme.evPalette.charcoal[900],
      padding: `${theme.spacing(1.25)}px ${theme.spacing(1.25)}px ${theme.spacing(1.25)}px`,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: '500',
      height: '42px',
      borderBottom: `1px solid ${theme.evPalette.charcoal['500']}`,
    },
    guestName: {
      color: '#fff',
      padding: `${theme.spacing(1.25)}px ${theme.spacing(1.25)}px ${theme.spacing(1.25)}px`,
      fontSize: theme.typography.pxToRem(16),
      lineHeight: theme.typography.pxToRem(22),
      fontWeight: '500',
      height: '42px',
    },
    userMenu: {
      width: theme.spacing(25),
    },
    settingsOnSide: {
      marginRight: theme.spacing(1),
    },
    settingsBelow: {
      marginTop: theme.spacing(0.3),
    },
    listItemIcon: {
      minWidth: theme.spacing(3.5),
    },
    popper: {
      zIndex: 10001,
    },
    signOutIcon: {
      width: theme.spacing(2),
      height: theme.spacing(2),
    },
    listStyle: {
      padding: `${theme.spacing(0.75)}px ${theme.spacing(1.5)}px`,
      '&:hover': {
        backgroundColor: theme.evPalette.charcoal[100],
        cursor: 'pointer',
      },
    },
    listText: {
      color: theme.evPalette.charcoal[700],
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(18),
      fontWeight: '500',
    },
  };
});

export default useStyles;
